module.exports = __webpack_public_path__ + "res/img_usage_type_party.215257a1104fc0a8ee515496bc8f928d.png";